import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-side-panel',
  standalone: true,
  imports: [],
  templateUrl: './auth-side-panel.component.html',
  styleUrl: './auth-side-panel.component.scss'
})
export class AuthSidePanelComponent {

}
